import React from "react";
import HomeComponent from "./components/home-component/HomeComponent";
import { FeaturesHomePageProps } from "./HomePageProps";
import styled from "@emotion/styled";
import {Box} from "@mediaspace/shared/styled";

const StyledHomePageContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
});

const Spacer = styled(Box)(({ theme }) => ({
    height: 60,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        height: 40
    }
}));

export function HomePage({ components = [] }: FeaturesHomePageProps) {
    return (
        <StyledHomePageContainer className="kms-ds-homepage">
            {components.map((component, index) => (
                <>
                    {index === 0 && component.id !== "hero-unit-text-and-counter" && component.id !== "hero-unit-player-carousel" && <Spacer />}
                    {index > 0 && <Spacer />}
                    <HomeComponent key={index} {...component} />
                </>
            ))}
            {components.length > 0 && <Spacer />}
        </StyledHomePageContainer>
    );
}

export default HomePage;
